export const HabitatTokenAuth = {
    HeaderName: "HabitatToken"
};
